import { createSlice } from "@reduxjs/toolkit";

const parametrosCalculadosSlice = createSlice({
  name: "calculated_parameter",
  initialState: {
    currentParametrosCalculados: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    parametros_calculadosStart: (state) => {
      state.isFetching = true;
    },
    parametros_calculadosSuccess: (state, action) => {
      state.isFetching = false;
      state.currentParametrosCalculados = action.payload;
    },
    parametros_calculadosFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    createParametro_calculadoStart: (state) => {
      state.isFetching = true;
    },
    createParametro_calculadoSuccess: (state, action) => {
      state.isFetching = false;
      state.currentParametrosCalculados = [
        ...(state.currentParametrosCalculados || []),
        action.payload.data,
      ];
      state.errorCreate = false;
    },
    createParametro_calculadoFailure: (state) => {
      state.isFetching = false;
      state.errorCreate = true;
    },
    logoutInfoparametros_calculados: (state) => {
      state.currentParametrosCalculados = null;
      state.isFetching = false;
      state.error = false;
      state.errorCreate = false;
    },
  },
});

export const {
  parametros_calculadosStart,
  parametros_calculadosSuccess,
  parametros_calculadosFailure,
  createParametro_calculadoStart,
  createParametro_calculadoSuccess,
  createParametro_calculadoFailure,
  logoutInfoparametros_calculados,
} = parametrosCalculadosSlice.actions;
export default parametrosCalculadosSlice.reducer;
